import React from 'react';
import { Bubble } from 'prophesier/dist/wrapper/index-with-deps-react.js';
import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';

const data = [{
    "ax": "03/29/2017 10:00 AM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 11:00 AM",
    "ay": 6.5,
    "aValue": 15,
    "attempts": 10
}, {
    "ax": "03/29/2017 12:00 PM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 30
}, {
    "ax": "03/29/2017 1:00 PM",
    "ay": 6.9,
    "aValue": 55,
    "attempts": 20
}, {
    "ax": "03/29/2017 2:00 PM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 3:00 PM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/29/2017 4:00 PM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 5:00 PM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 30
}, {
    "ax": "03/29/2017 6:00 PM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 7:00 PM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 8:00 PM",
    "ay": 6.3,
    "aValue": 55,
    "attempts": 30
}, {
    "ax": "03/29/2017 9:00 PM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 10:00 PM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 11:00 PM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 12:00 AM",
    "ay": 6.3,
    "aValue": 55,
    "attempts": 20
}, {
    "ax": "03/30/2017 1:00 AM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/30/2017 2:00 AM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 3:00 AM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 4:00 AM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 30
}, {
    "ax": "03/30/2017 5:00 AM",
    "ay": 6.9,
    "aValue": 15,
    "attempts": 20
}, {
    "ax": "03/30/2017 6:00 AM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/30/2017 7:00 AM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/30/2017 8:00 AM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 9:00 AM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 30
}];

const names = ["10 Attempts", "20 Attempts", "30 Attempts"]

const colorPrim = ["rgb(91,100,114)", "rgb(196,175,84)", "rgb(86,130,216)"];

class BubbleSample extends React.Component {
    constructor() {
        super();
        this.state = { 
            title: true,
            legends: true,
            exprt: false
             }
    }
    _onChange(event) {
        let { title, legends, exprt } = this.state
                switch(event) {
            case "title":
                this.setState({ title: !title })
                break;
            case "legends":
                this.setState({ legends: !legends })
                break;
            case "exprt":
                this.setState({ exprt: !exprt })
                break;
        }
    }
    render() {
        let { title, legends, exprt } = this.state
        return (
            <div>
                <Box direction='row'
                    justify='center'
                    align='center'
                    wrap={true}
                    reverse={false}
                    margin='none'
                    >
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >
         <CheckBox 
        name='title'
        id='title'
        label='Title'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'title')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >
         <CheckBox 
        name='legends'
        id='legends'
        label='Legends'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'legends')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >
         <CheckBox 
        name='export'
        id='export'
        label='Export'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'export')}
         />
         </Box>
                    </Box>
                {/* <BubbleEverywhere
                    data={data}
                    names={names}
                    xformat={'date'}
                    barcolor={colorPrim}
                    xtitle={(title) ? 'Time': ''}
                    ytitle={(title) ? 'Title for Y':''}
                    exprt={exprt}
                    legends={legends}
                ></BubbleEverywhere> */}
            </div>
        );
    }
}

export default BubbleSample;

export const textCode = `
import React from 'react';
import { BubbleEverywhere } from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data = [{
    "ax": "03/29/2017 10:00 AM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 11:00 AM",
    "ay": 6.5,
    "aValue": 5,
    "attempts": 10
}, {
    "ax": "03/29/2017 12:00 PM",
    "ay": 6.3,
    "aValue": 5,
    "attempts": 30
}, {
    "ax": "03/29/2017 1:00 PM",
    "ay": 6.9,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 2:00 PM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 3:00 PM",
    "ay": 6.5,
    "aValue": 5,
    "attempts": 10
}, {
    "ax": "03/29/2017 4:00 PM",
    "ay": 6.3,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 5:00 PM",
    "ay": 6.9,
    "aValue": 5,
    "attempts": 30
}, {
    "ax": "03/29/2017 6:00 PM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 7:00 PM",
    "ay": 6.5,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 8:00 PM",
    "ay": 6.3,
    "aValue": 5,
    "attempts": 30
}, {
    "ax": "03/29/2017 9:00 PM",
    "ay": 6.9,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 10:00 PM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 11:00 PM",
    "ay": 6.5,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/30/2017 12:00 AM",
    "ay": 6.3,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/30/2017 1:00 AM",
    "ay": 6.9,
    "aValue": 5,
    "attempts": 10
}, {
    "ax": "03/30/2017 2:00 AM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/30/2017 3:00 AM",
    "ay": 6.5,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/30/2017 4:00 AM",
    "ay": 6.3,
    "aValue": 5,
    "attempts": 30
}, {
    "ax": "03/30/2017 5:00 AM",
    "ay": 6.9,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/30/2017 6:00 AM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 10
}, {
    "ax": "03/30/2017 7:00 AM",
    "ay": 6.5,
    "aValue": 5,
    "attempts": 10
}, {
    "ax": "03/30/2017 8:00 AM",
    "ay": 6.3,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/30/2017 9:00 AM",
    "ay": 6.9,
    "aValue": 5,
    "attempts": 30
}];

const names = ["10 Attempts", "20 Attempts", "30 Attempts"]

const colorPrim = ["rgb(91,100,114)", "rgb(196,175,84)", "rgb(86,130,216)"];

class BubbleSample extends React.Component {
    constructor() {
        super();
        this.state = { data: data, names: names }
    }
    render() {
        return (
            <div>
                <BubbleEverywhere
                    data={this.state.data}
                    names={this.state.names}
                    xformat={'date'}
                    barcolor={colorPrim}
                    xtitle={'Time'}
                    ytitle={'Title for Y'}
                ></BubbleEverywhere>
            </div>
        );
    }
}

export default BubbleSample;
`

export const src = `
const data = [{
    "ax": "03/29/2017 10:00 AM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 11:00 AM",
    "ay": 6.5,
    "aValue": 5,
    "attempts": 10
}, {
    "ax": "03/29/2017 12:00 PM",
    "ay": 6.3,
    "aValue": 5,
    "attempts": 30
}, {
    "ax": "03/29/2017 1:00 PM",
    "ay": 6.9,
    "aValue": 5,
    "attempts": 20
}, {
    "ax": "03/29/2017 2:00 PM",
    "ay": 6.1,
    "aValue": 5,
    "attempts": 20
}];

const names = ["10 Attempts","20 Attempts","30 Attempts"]
const template = "<bubble-everywhere></bubble-everywhere>";

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        const sampleCode  = document.querySelector("._sampleDomElement");
        sampleCode.innerHTML = template
        const element = document.querySelector("bubble-everywhere")
        element.data = data;
        element.names = names;
        element.xformat = "date";
        element.xtitle = "Title for X";
        element.ytitle = "Title for Y";
    }
}
`



// WEBPACK FOOTER //
// ./src/samples/BubbleHomeReact.js